<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div>
        <div class="card">
          <div class="card-header">
            <router-link to="/video/tambah">
              <a-button type="primary"> + Tambah Video Vertical </a-button>
            </router-link>
          </div>
          <div class="card-body">
            <tabel-video />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabelVideo from '@/components/tables/video'
export default {
  components: {
    TabelVideo,
  },
  data() {
    return {
      test: null,
    }
  },
}
</script>

<style lang="scss" module></style>
